import { Injectable } from '@angular/core';

import { RestService } from "../../../core/services/rest.service";
import { apiName } from "./data.service";
import { ContaContabil } from "./conta-contabil.model";

@Injectable()
export class ContaContabilApiService {

  constructor(
    private _restService: RestService
  ) { }

  onPost(object: ContaContabil, done: any) {
    this._restService.onPost(apiName, object, done);
  }

  onPut(object: ContaContabil, done: any) {
    this._restService.onPut(apiName, object, done);
  }

  onDelete(objectId: number, done: any) {
    this._restService.onDelete(apiName, objectId, done);
  }

  onGetAll(done: any) {
    var filter: any = {"order":"codigo","include":["pai","tipo"]};
    this._restService.onGetPost(apiName, filter, done);
  }

  onGetById(objectId: number, done: any) {
    var filter: any = {"include":"pai"};
    this._restService.onGetPostId(apiName, objectId, filter, done);
  }

  onGetFather(fatherId: number, done: any) {
    this._restService.onGet(apiName + '/pai/' + fatherId, done);
  }

  onGetByCode(code: string, done: any) {
    var filter: any = {"where":{"codigo":code}};
    this._restService.onGetPost(apiName, filter, done);
  }

  onGetApiUrl() {
    return apiName;
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/contas/conta-contabil/shared/conta-contabil-api.service.ts
 **/